/**
 * mwApp.preferences module <br>
 * Edit account's preferences
 *
 * @namespace mwApp/preferences
 */

import PreferencesCtrl from './preferences.controller'
import preferencesConfig from './preferences.config'

export default
angular.module('mwApp.preferences', [])
  .config(preferencesConfig)
  .controller('PreferencesCtrl', PreferencesCtrl)
